import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CallbackComponent } from './callback/callback.component';
import { AuthGuard } from './core/guard/auth.guard';
import { LayoutComponent } from './layout/layout.component';
import { LoginDlgComponent } from './layout/login-dlg/login-dlg.component';
import { RefreshTokenComponent } from './sub-system/refresh-token/refresh-token.component';
import { LogoutAllComponent } from './sub-system/logout-all/logout-all.component';


const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/pages' },
  { path: 'login', component: LoginDlgComponent },
  { path: 'login/callback', component: CallbackComponent },
  {
    path: 'pages',
    canActivate: [AuthGuard],
    component: LayoutComponent,
    data: {
      breadcrumbStr: ''
    },
    children: [
      {
        path: 'tokenInfo',
        loadChildren: () => import('./pages/token-info/token-info.module').then(m => m.TokenInfoModule),
        data: {
          title: 'project.m1.name'

        }
      },
      {
        path: 'dailycallspace',
        loadChildren: () => import('./pages/token-info/token-info.module').then(m => m.TokenInfoModule),
        data: {
          title: 'project.m3.name'
        }
      },
      {
        path: 'containerType',
        loadChildren: () => import('./pages/token-info/token-info.module').then(m => m.TokenInfoModule),
        data: {
          title: 'project.m41.name'
        }
      },
      {
        path: 'sendmail',
        loadChildren: () => import('./pages/token-info/token-info.module').then(m => m.TokenInfoModule),
        data: {
          title: 'project.m42.name'
        }
      },
      {
        path: 'sendmailtoforward',
        loadChildren: () => import('./pages/token-info/token-info.module').then(m => m.TokenInfoModule),
        data: {
          title: 'project.m43.name'
        }
      },
      {

        path: 'wmsm-pages',
        loadChildren: () => import('./WMSM-Pages/WMSMPages.module').then(m => m.WMSMPagesModule),
        data: {
          breadcrumbStr: 'platformTitle'
        },
      }
    ]
  },
  {
    path: 'refreshtoken',
    component: RefreshTokenComponent
  },
  {
    path: 'logoutall',
    component: LogoutAllComponent
  },
  {
    path: '**',
    loadChildren: () => import('./pages/page-not-found/page-not-found.module').then(m => m.PageNotFoundModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
